
import { computed, defineComponent } from "vue";
import DataSourceFilters from "@/components/drawers/right/DataSourceFilters.vue";
import { useGammaData } from "@/services";

export default defineComponent({
  name: "DataFilters",
  components: {
    DataSourceFilters,
  },
  setup: () => ({
    activeSourceId: computed(() => useGammaData().activeSourceId),
  }),
});
